import { Component } from '@angular/core';
import { UilabMatStepperModule } from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface StepperExample {
    readonly variant: 'basic';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
}

@Component({
    selector: 'avd-stepper-examples',
    templateUrl: './stepper-examples.component.html',
    styleUrls: ['./stepper-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatStepperModule,
    ],
})
export class StepperExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink =
        'https://calm-mushroom-0d2458d1e.2.azurestaticapps.net/?path=/story/components-stepper--default';
    readonly repoLink =
        'https://dev.azure.com/AVEVA-VSTS/UX/_git/uilab-base?version=GBfeat/angular-material-components&path=/projects/components/src/lib/stepper';

    readonly examples: readonly StepperExample[] = [
        {
            variant: 'basic',
            label: 'Basic Stepper',
            description:
                'Use a stepper to guide users through a sequence of related steps.',
            htmlSnippet: `<uilab-mat-stepper>
  <uilab-mat-step label="Step 1">
    <p>Provide account details.</p>
  </uilab-mat-step>
  <uilab-mat-step label="Step 2">
    <p>Confirm your preferences.</p>
  </uilab-mat-step>
  <uilab-mat-step label="Step 3">
    <p>Review and submit.</p>
  </uilab-mat-step>
</uilab-mat-stepper>`,
        },
    ];
}
